
import SettingContext from "./context/setting-contentxt/setting-context"
import {useCallback, useContext} from 'react'
import {AlertColor} from '@mui/material/Alert'
import { getLanguage } from "react-multi-lang"
import {AxiosError} from 'axios'
export const useNotification =()=>{
    const {setAlert}=useContext(SettingContext)
    const alert=useCallback((message:{en:string,ar:string},type:AlertColor)=>{
        setAlert((pre:any)=>({...pre,openAlert:true
            ,alertMessage:getLanguage()==='en'?message.en:message.ar,
            alertType:type
        }))
    },[setAlert])
    const alertError500=useCallback((error:AxiosError<any>)=>{
        if (error.response?.status===500){
        setAlert((pre:any)=>({...pre,openAlert:true,alertType:'error',
        alertMessage:getLanguage()==='en'?'Something wrong has happend ':
              ' حدث  خطأ ما'}))
        }
        if (error.response?.status===422){
            if (error.response.data && error.response.data.errors){
                // eslint-disable-next-line   array-callback-return
                Object.keys(error.response.data.errors).map(ele=>{
                    if (Array.isArray(error.response?.data.errors[ele])){

                        setAlert(
                            (pre:any)=>({...pre,openAlert:true,alertType:'error',
                            alertMessage:error.response?.data.errors[ele][0]
                            })
                        )
                    }
                })
            }
            if (error.response.data && error.response.data.data){
                let target =error.response.data.data
                let key_errors=Object.keys(target)
                 // eslint-disable-next-line   array-callback-return
                key_errors.map(ele=>{
                    if (Array.isArray(target[ele])){
                        setAlert(
                            (pre:any)=>({...pre,openAlert:true,alertType:'error',
                            alertMessage:target[ele]
                            })
                        )
                    }
                })
            }
        }
        else {
            if (error.response?.data && error.response.data.message){
              

                        setAlert(
                            (pre:any)=>({...pre,openAlert:true,alertType:'error',
                            alertMessage:error.response?.data.message
                            })
                        )
                    
                
            }
        }
              
    },[setAlert])
    return {alert,alertError500}
}